exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-card.contact-person {\n  padding: 12px 12px; }\n  mat-card.contact-person:not(:first-child) {\n    margin-top: 8px; }\n  mat-card.contact-person mat-card-header i {\n    display: inline-block;\n    margin-left: 14px;\n    font-size: 80%;\n    margin-top: 3px; }\n  mat-card.contact-person p {\n    padding-left: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/CustomersModule/CustomerContactPersonsListComponent/customer-contact-persons-list.component.scss
// module id = ../../../../../src/CustomersModule/CustomerContactPersonsListComponent/customer-contact-persons-list.component.scss
// module chunks = main